import React from 'react';

const BadgeList = ({ badges }) => {
  const getTooltipAttributes = tooltipText => {
    if(tooltipText){
      return {
        role: 'tooltip',
        'data-toggle': 'tooltip',
        'data-original-title': tooltipText,
        tabIndex: '0'
      }
    }

    return {}
  }

  return(
    <div className="row mx-0 cui-event-badges">
      { badges && badges.map((badge, index) => {
        return <span
          key={ index }
          className="cui-badge-info large font-500 py-1 px-3 mr-2 mb-2"
          { ...getTooltipAttributes(badge.tooltipText) }
        >
          <i className={ `fa-regular ${badge.iconClass} fa-fw m-r-xs` } />
          { badge.text }
        </span>
      }) }
    </div>
  );
}

export default BadgeList;